import styled from 'styled-components';

import { breakpoints, getSemanticColor } from '@notino/react-styleguide-v20';

import { IDividerProps } from './model';

export const StyledDivider = styled.div<IDividerProps>`
  background-color: ${({ color }) => (color ? getSemanticColor(color) : 'transparent')};
  display: block;
  height: ${({ height }) => height};
  margin: 1rem 0;
  position: relative;

  @media (min-width: ${breakpoints.md}) {
    margin: 1.25rem 0;
  }
`;
